import { type SortingState } from "@tanstack/react-table";

export const DEFAULT_PAGE_SIZE = 20;
export const EMPTY_VALUE = "-";
export const SYSTEM_USER_LABEL = "System";

export const COMPACT_HEADER_CLASS = "px-3 py-2 !whitespace-normal leading-tight";
export const ACTION_BUTTON_CLASS = "w-[4.75rem]";

export const DEFAULT_SORTING: SortingState = [{ id: "name", desc: false }];

export const FARMER_IDENTIFICATION_SORT_OPTIONS = [
  { id: "name", translationKey: "configuration.common.name" },
  { id: "code", translationKey: "configuration.common.code" },
  { id: "format", translationKey: "farmerIdentification.form.identificationFormat" },
  { id: "length", translationKey: "farmerIdentification.list.column.length" },
  { id: "lastUpdated", translationKey: "configuration.list.column.lastUpdated" },
  { id: "created", translationKey: "configuration.list.column.created" },
  { id: "active", translationKey: "configuration.common.active" },
] as const;
